import { toast } from '@/helpers/toast/toast.helper'
import { updateActiveChatAction, updateMessageTextAction } from '@/redux/chat/actions'
import { update as updateChat } from '@/redux/chat/sagas/_http/chat'
import { save } from '@/redux/chat/sagas/_http/message'
import { ApplicationState } from '@/redux/store'
import { t } from 'i18next'
import { put, select } from 'redux-saga/effects'
import { editTextMessageAction } from '../../handles/editTextMessageAction'
import { EditTextMessageFailedError, MessageNotEditableError } from '../createMessageSaga/errors'
import { isMessageOlderThan15Minutes } from '../createMessageSaga/helpers'
import { editTextMessage } from '../createMessageSaga/http/message'
import { EditTextMessageResponse } from '../createMessageSaga/http/message/types'

export function* editTextMessageSaga(action: ReturnType<typeof editTextMessageAction.request>) {
  const { message, campaign, newText } = action.payload
  try {
    if (isMessageOlderThan15Minutes(message)) throw new MessageNotEditableError()

    const response: EditTextMessageResponse = yield editTextMessage({
      campaignId: campaign.id,
      token: campaign.token,
      phone: message.phone,
      bridgeMessageId: message.messageId,
      message: newText
    })

    if (response?.value !== undefined && !response.value) throw new EditTextMessageFailedError(response?.message)

    yield save({ ...message, messageText: newText, isEdit: true })

    yield put(updateMessageTextAction({ messageId: message.messageId, messageText: newText }))

    const activeChat = yield select((state: ApplicationState) => state.chatReducer.activeChat)
    if (activeChat?.lastMessage?.messageId === message.messageId) {
      const updatedLastMessage = { ...activeChat.lastMessage, messageText: newText }
      yield updateChat(activeChat.id, { lastMessage: updatedLastMessage })
      yield put(updateActiveChatAction({ lastMessage: updatedLastMessage }))
    }

    yield put(editTextMessageAction.success())
  } catch (error) {
    const errorMessage =
      error instanceof MessageNotEditableError
        ? t('translation:messageNotEditable')
        : error instanceof EditTextMessageFailedError && error.message
        ? error.message
        : t('translation:editMessageError')

    toast({ type: 'error', message: errorMessage })
    yield put(editTextMessageAction.failure({ isError: true }))
  }
}
